module.exports = __webpack_public_path__ + "img/bg-relation.6906de11.png";